<div>
    <app-header></app-header>
 </div>
<section class="my-sm-5 my-4">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="patnerbanner">
                    <img src="assets/images/new_img/patner-banner.jpg" class="img-fuild imgborder" alt="Patner With Us">
                    <div class="patner-detail">
                        <div>
                            <h1> Partner with Us </h1>
                            <p> Fill out the details to become our Partner and Join Forces with Us </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="mb-sm-5 mb-3">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
                <img src="assets/images/new_img/patner.jpg" class="img-fluid w-100" alt="">
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12">
                <div class="partnerwithform">
                    <div class="row">
                        <div class="col-md-12 mt-sm-2 mt-2">
                            <h2 class="c-mobile-view1"> Partner with Us </h2>
                        </div>
                    </div>
                    <form [formGroup]="addForm" (submit)="onSubmit(addForm.value)">
                        <div class="row">
                            <div class="col-md-12 mb-2">
                                <input type="hidden" class="w-100 locationdata form-control"
                                formControlName="utm_source" >
                        <input type="hidden" class="w-100 locationdata form-control"
                                formControlName="utm_medium">
                        <input type="hidden" class="w-100 locationdata form-control"
                                formControlName="utm_campaign">
                        <input type="hidden" class="w-100 locationdata form-control"
                                formControlName="utm_term">
                        <input type="hidden" class="w-100 locationdata form-control"
                                formControlName="utm_content">
                        <input type="hidden" class="w-100 locationdata form-control"
                                formControlName="utm_placement">
                                </div>
                            <div class="col-md-12 mb-2">
                                <div class="locateyourdata ">
                                    <input type="text" maxlength="50" class="w-100 locationdata form-control"
                                        formControlName="company_name" placeholder="Company Name">
                                          <div *ngIf="submitted && addForm.controls['company_name'].hasError('required')" class="text-danger mt-1">
                                            Company Name is required.
                                          </div>
                                </div>
                            </div>
                            <div class="col-md-12 mb-2">
                                <div class="locateyourdata ">
                                    <input type="text" maxlength="50" class="w-100 locationdata form-control"
                                        formControlName="person_name" placeholder="Contact Person Name">
                                          <div *ngIf="submitted && addForm.controls['person_name'].hasError('required')" class="text-danger mt-1">
                                            Contact Person Name is required.
                                          </div>

                                </div>
                            </div>
                            <div class="col-md-12 mb-2">
                                <div class="locateyourdata ">
                                    <input type="text" maxlength="15" class="w-100 locationdata form-control"
                                        formControlName="designation" placeholder="Contact Person Designation">
                                </div>
                                
                                  <div *ngIf="submitted && addForm.controls['designation'].hasError('required')" class="text-danger mt-1">
                                    Contact Person Designation is required.
                                  </div>

                            </div>
                            <div class="col-md-12 mb-2">
                                <div class="locateyourdata">
                                    <input type="email" maxlength="50" class="w-100 locationdata form-control"
                                        formControlName="email" placeholder="Email ID">
                                       
                                          <div *ngIf="submitted && addForm.controls['email'].hasError('required')" class="text-danger mt-1">
                                            Email ID is required.
                                          </div>
                                          <div *ngIf="addForm.controls['email'].hasError('pattern') && (addForm.controls['email'].dirty)" class="text-danger mt-1">
                                            Please enter a valid email address.
                                          </div>
                                </div>
                            </div>
                            <div class="col-md-12 mb-2">
                                <div class="locateyourdata ">
                                    <p class="cuntrycode"> +91 </p>
                                    <input type="text" maxlength="10"
                                        class="w-100 locationdata form-control inputnumber"
                                        formControlName="mobile_number" placeholder="Enter Mobile Number">
                                        <div *ngIf="addForm.controls['mobile_number'].invalid && addForm.controls['mobile_number'].touched" class="text-danger mt-1">
                                            Mobile Number must be number.
                                          </div>
                                          <span class="text-danger mt-1" *ngIf="addForm.get('mobile_number').hasError('maxlength') && submitted">
                                            Min 10 digit
                                          </span>   
                                          
                                </div>
                            </div>
                            <div class="col-md-12 mb-2">
                                <div class="locateyourdata ">
                                    <input type="text" maxlength="100" class="w-100 locationdata form-control"
                                        formControlName="website_url" placeholder="Website URL">
                                        
                                          <div *ngIf="submitted && addForm.controls['website_url'].hasError('required')" class="text-danger mt-1">
                                            Website URL is required.
                                          </div>
                                </div>

                            </div>
                            <div class="col-md-6 mb-2">
                                  <div class="locateyourdata ">
                                    <mat-form-field appearance="fill" class="mat-select-display w-100 mb-2">
                                        <mat-select placeholder="State" formControlName="state"
                                            (selectionChange)="onStateChange($event)" #select2 panelClass="s1" (closed)="clearSearch(searchInput)">
                                            <div class="search-containers" mat-select-trigger>
                                                <mat-form-field appearance="standard" class="search-field">
                                                  <input matInput placeholder="Search State" #searchInput class="ms-2"
                                                    (input)="filterStates(searchInput.value)" 
                                                    (click)="$event.stopPropagation()" />
                                                </mat-form-field>
                                              </div>
                                            <mat-option *ngFor="let category1 of filteredStateData" [value]="category1.id?.toString()">
                                                {{ category1.name }}
                                            </mat-option>
                                            <mat-option *ngIf="filteredStateData?.length === 0" disabled>No items
                                                available</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                      <div *ngIf="submitted && addForm.controls['state'].hasError('required')" class="text-danger mt-1">
                                        State is required.
                                      </div>
                                </div>
                              
                            </div>
                            <div class="col-md-6 mb-2">
                                  <div class="locateyourdata ">
                                    <mat-form-field appearance="fill" class="mat-select-display w-100 mb-2"
                                        *ngIf="cityData?.length">
                                        <mat-select placeholder="City" formControlName="city" #selectCity
                                            panelClass="s2" (closed)="clearSearch1(searchInput1)">
                                            <div class="search-containers" mat-select-trigger>
                                                <mat-form-field appearance="standard" class="search-field">
                                                  <input matInput placeholder="Search City" #searchInput1 class="ms-2"
                                                    (input)="filterCity(searchInput1.value)" (click)="$event.stopPropagation()" />
                                                </mat-form-field>
                                              </div>
                                            <mat-option *ngFor="let city of filteredcityData" [value]="city?.id?.toString()">
                                                {{ city.city }}
                                            </mat-option>
                                            <mat-option *ngIf="filteredcityData?.length === 0" disabled>No items
                                                available</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- <div *ngIf="addForm.controls['city'].invalid && addForm.controls['city'].touched" class="text-danger mt-1">
                                        City is required.
                                      </div> -->
                                      <div *ngIf="submitted && addForm.controls['city'].hasError('required')" class="text-danger mt-1">
                                        City is required.
                                      </div>
                                </div>
                            </div>
                            <div class="col-md-12 formsinput mb-2">
                                <div class="customwidth position-relative mb-2 textarea-container">
                                    <textarea type="text" class="form-control emaildata ps-3"
                                        formControlName="description" maxlength="1500"
                                        placeholder="Additional Information (optional)"></textarea>
                                       
                                </div>
                            </div>
                            <div class="d-flex btnbox justify-content-start mt-3">
                                <button type="submit" class="addListing" name="addListing"[disabled]="addForm.invalid" [ngClass]="{active:!addForm.invalid}">
                                    Partner with Us </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
<div>
    <app-footer></app-footer>
</div>